// import { lruCache } from "../lib/cache"
// import { getEnabledMenus } from "../lib/utils"
import { drupal } from "../lib/drupal"

// const enabledMenus = getEnabledMenus().join("_")

const fetchMenu = async ({ name, locale, auth }) => {
	const uid = auth?.auth?.user?.id || 0
	const cacheKey = `config:system.menu.${name} user:${uid} language:${locale}`
	// console.log("====", auth?.auth)
	// // Cache-first
	// if (lruCache.has(cacheKey)) {
	// 	return new Promise((resolve) => {
	// 		resolve(lruCache.get(cacheKey))
	// 	})
	// }

	// const response = await fetch(
	// 	`${process.env.NEXT_PUBLIC_DRUPAL_BASE_URL}/${locale}/_menus?menu_name=${name}`
	// )
	// if (!response.ok) {
	// 	const message = `[fetchMenu] An error has occured: ${response.status}`
	// 	throw new Error(message)
	// }

	// const data = await response.json()
	// // lruCache.set(cacheKey, data)

	let options = {
		withCache: true,
		cacheKey: cacheKey,
	}

	if (auth?.auth?.user?.id > 0) {
		options["withAuth"] = () => `Bearer ${auth?.auth.accessToken}`
		options["headers"] = {
			"X-Auth-Provider": auth?.auth.provider,
		}
	}

	// console.log(options)

	const data = await drupal.getMenu(name, locale, options)
	return data
}

const formatMenu = (name, data) => {
	return {
		name,
		items: data?.items || [],
	}
}

export const getMenu = async (name, locale, auth) => {
	return fetchMenu({ name, locale, auth }).then((res) => formatMenu(name, res))
}

export const getMenus = async (names = [], locale, auth) => {
	const requests = names.map((name) =>
		fetchMenu({ name, locale, auth }).then((res) => formatMenu(name, res))
	)
	return Promise.all(requests)
}
